import { Popover } from "antd";
import cls from "classnames";
import { META_DATA } from "logic/src/constants";
import UserCenter from "@/components/UserCenter";
import { ReactComponent as Person } from "logic/src/components/icons/person.svg";
import { ReactComponent as Frame } from "logic/src/components/icons/frame.svg";
import styles from "./index.module.scss";
import { useState } from "react";
import AppQRCode from "@/components/AppQRCode";

const UserCenterFooter: React.FC<{
  resetInit: () => void;
  fold: boolean;
}> = ({ resetInit, fold }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={cls(styles.container, fold && styles.fold)}>
      {/* <Person className={styles.presonIcon} /> */}
      <Popover
        title={false}
        arrow={false}
        placement="topRight"
        open={visible}
        content={
          <UserCenter
            resetInit={resetInit}
            onMenuClick={() => setVisible(false)}
          />
        }
        onOpenChange={open => setVisible(open)}
        overlayInnerStyle={{
          padding: 0,
        }}
      >
        <Person className={styles.presonIcon} />
        {/* <Frame className={styles.frameIcon} /> */}
      </Popover>
      {META_DATA.area === "hk" && (
        <AppQRCode className={styles.qrcodeIcon} right={!!fold} />
      )}
      {/* <QRCodeIcon className={styles.qrcodeIcon} /> */}
    </div>
  );
};
export default UserCenterFooter;
